import { EditFeatureInput } from 'features/siteMap/popupMenus/editMode/editFeature/EditFeatureInput'
import React, { FC } from 'react'

interface SVNumberInputProps {
  id: string
  value: number
  step: number
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  width?: number
}

export const SVNumberInput: FC<SVNumberInputProps> = (props) => {
  let newValue = props.value.toString().replace(/^0+/, '')
  if (newValue === '') newValue = '0'

  return (
    <EditFeatureInput
      id={props.id}
      type='number'
      value={newValue}
      step={props.step}
      onChange={(e) => {
        props.onChange(e)
      }}
      style={{
        width: props.width === undefined ? `100%` : `${props.width}px`,
      }}
    />
  )
}
